import React from 'react';
interface WhatsAppButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'outline';
  className?: string;
}
export function WhatsAppButton({
  children,
  variant = 'primary',
  className = '',
  ...props
}: WhatsAppButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center gap-2 px-8 py-4 font-heading text-lg tracking-wider uppercase transition-all duration-300 transform hover:-translate-y-1';
  const variants = {
    primary: 'bg-brand-red text-white hover:bg-red-700 shadow-[0_0_20px_rgba(225,29,42,0.3)] hover:shadow-[0_0_30px_rgba(225,29,42,0.5)]',
    outline: 'border-2 border-brand-red text-brand-red hover:bg-brand-red hover:text-white'
  };
  const href = 'https://wa.me/54911XXXXXXXX?text=Hola,%20quiero%20solicitar%20un%20turno%20en%20Morello%20Detailing.';
  return <a href={href} target="_blank" rel="noopener noreferrer" className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-130">
      {children}
    </a>;
}